export default __webpack_public_path__ + "static/media/dashboard-banner-mobile.1ecb00c4.svg";